import client from './main-client';

export const getFormsApi = (params) => client().get('/form-builder', { params });
